// 页面权限
export const BANNER_LIST_PAGE_UUID = '629c4daa-0901-460f-abc7-5073b5a0e04d'
// 操作权限
export const BANNER_ACTION_UUID = '9a489a92-3983-4b94-8a9e-ec0aae1850cf'
